import styled from "styled-components";
import { Link } from "react-router-dom";

export const PageContainer = styled.div`
  background-color: #221f3c;
  color: #fff;
  text-align: center;
`;

export const HeroSection = styled.div`
  background-image: url(${({ $bg }) => $bg});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 650px;
  position: relative;
  z-index: 1;
  gap: 20px;
`;

export const HeroTitle = styled.h1`
  font-size: 2.5rem;
  margin: 0;
`;

export const InfoSection = styled.div`
  background-color: #fff;
  color: #221f3c;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

export const InfoText = styled.div`
  max-width: 800px;
  font-size: 1.1rem;
  line-height: 1.8;
  text-align: left;
  h2 {
    margin: 0 0 1rem;
    font-size: 2rem;
  }
  p {
    margin-bottom: 1rem;
  }
`;

export const BulletCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 800px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const BulletCard = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  flex: 1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: left;
  h3 {
    margin-top: 0;
    margin-bottom: 10px;
  }
  ul {
    list-style: disc;
    padding-left: 20px;
    margin: 0;
  }
  li {
    margin-bottom: 8px;
  }
  li:last-child {
    margin-bottom: 0;
  }
`;

export const InfoImage = styled.img`
  width: 100%;
  max-width: 500px;
  border-radius: 10px;
`;

export const Navigation = styled.div`
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  gap: 20px;
`;

export const NavButton = styled(Link)`
  color: ${({ $active }) => ($active ? "#221f3c" : "#fff")};
  background-color: ${({ $active }) => ($active ? "#fff" : "#0096ff")};
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;

  &:hover {
    background-color: ${({ $active }) => ($active ? "#e0e0e0" : "#0076cc")};
  }
`;

// FlagImage was removed as flags are no longer displayed in the hero section.

export const CardsWrapper = styled.div`
  padding: 40px 0;
`;

export const CardsContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: visible;
`;

export const RetreatCard = styled.div`
  background-color: #fff;
  color: #221f3c;
  border-radius: 10px;
  width: 90%;
  max-width: 700px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  transition: transform 0.5s ease, opacity 0.5s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: visible;

  &.active {
    opacity: 1;
    z-index: 3;
    transform: translateX(-50%) scale(1);
  }

  &.prev {
    opacity: 0.5;
    z-index: 2;
    transform: translateX(calc(-50% - 60%)) scale(0.85);
  }

  &.next {
    opacity: 0.5;
    z-index: 2;
    transform: translateX(calc(-50% + 60%)) scale(0.85);
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

export const CardContent = styled.div`
  padding: 20px;
  font-size: 1rem;
  line-height: 1.6;
  text-align: left;
`;

export const CardTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 1.5rem;
  text-align: center;
`;

export const CardDescription = styled.p`
  margin-bottom: 20px;
  font-size: 1rem;
  line-height: 1.6;
  text-align: left;
`;

export const Itinerary = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;

  > li {
    margin-bottom: 15px;
  }

  > li > ul {
    list-style: disc inside;
    padding-left: 20px;
    margin-top: 5px;
  }

  > li > ul > li {
    margin-bottom: 5px;
  }
`;

export const PartnerSection = styled.div`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(34, 31, 60, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const PartnerLabel = styled.span`
  font-size: 0.75rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: rgba(34, 31, 60, 0.6);
`;


export const CardNav = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 20px;
`;

export const NavArrow = styled.button`
  background-color: #0096ff;
  border: none;
  color: #fff;
  padding: 10px 15px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.2rem;

  &:hover {
    background-color: #0076cc;
  }
`;

